import makeContext from '@libs/makeContext';

import {
    SET_YEAR,
    TIMESHEET_NEXT_YEAR,
    TIMESHEET_PREV_YEAR
} from '../../context.actionTypes';

const currentYear = new Date().getFullYear();

const initialState = {
    data: {},
    year: currentYear,
    isNextDisabled: true
};

const reducer = (state, { type, payload }) => {
    switch (type) {
        case SET_YEAR: {
            const newYear = Number(payload);
            return {
                ...state,
                year: newYear,
                isNextDisabled: newYear >= currentYear
            };
        }
        default:
            return state;
    }
};

const middleware = (state, action, { fetchData }) => {
    switch (action.type) {
        case SET_YEAR: {
            fetchData({ year: Number(action.payload) });
            return action;
        }
        case TIMESHEET_NEXT_YEAR: {
            const nextYear = state.year + 1;
            fetchData({ year: nextYear });
            return { type: SET_YEAR, payload: nextYear };
        }
        case TIMESHEET_PREV_YEAR: {
            const prevYear = state.year - 1;
            fetchData({ year: prevYear });
            return { type: SET_YEAR, payload: prevYear };
        }
        default:
            return action;
    }
};

const [
    YearlyTimesheetsProvider,
    useYearlyTimesheetsState,
    useYearlyTimesheetsDispatch,
    useYearlyTimesheets
] = makeContext(reducer, initialState, {
    name: 'MyYearlyTimesheets',
    middleware
});

export {
    useYearlyTimesheets as default,
    YearlyTimesheetsProvider,
    useYearlyTimesheetsState,
    useYearlyTimesheetsDispatch,
    SET_YEAR,
    TIMESHEET_NEXT_YEAR,
    TIMESHEET_PREV_YEAR
};
